<template>
  <div>
    <div v-show="!loading">
      <v-row :justify="$vuetify.breakpoint.xs ? 'center' : 'end'">
        <v-col cols="auto" class="mt-2" @click="anexar">
          <icon v-if="opcaoEditar" name="paperclip" :size="20" style="cursor: pointer;" tooltip="Anexar Documento" />
        </v-col>
      </v-row>
      <v-row>
        <span class="texto-Iniciativa mb-4 ml-2">Iniciativas Institucionais aderidas pela Unimed </span>
        <v-col cols="12" sm="12" md="12" class="pt-0">
          <div class="iniciativas-lista px-4 mt-2" v-if="listaIniciativaFiltrada.length > 0">
            <v-row justify="end" align="start">
              <v-col cols="3">
                <span class="cardTextoIniciativas" v-if="listaIniciativaFiltrada.length > 0">Data Adesão</span>
              </v-col>
            </v-row>
            <ValidationObserver ref="observer">
              <v-row
                :style="$vuetify.breakpoint.xs ? 'height: auto !important' : 'height: 65px !important'"
                v-for="(iniciativa, index) in listaIniciativaFiltrada"
                :key="index"
                @mouseover="showByIndex = index"
                @mouseout="showByIndex = null"
              >
                <v-col cols="auto" md="1" :class="$vuetify.breakpoint.xs ? 'mt-1' : 'my-2'">
                  <switch-cadu
                    :number="index"
                    v-model="iniciativa.aderida"
                    @input="changeSwitch"
                    @index="(index) => (indexSwitch = index)"
                    :disabled="permissaoEditar"
                  />
                </v-col>
                <v-col cols="auto" sm="auto" md="8" :class="$vuetify.breakpoint.xs ? '' : 'my-1 mb-1'">
                  <v-tooltip top v-if="iniciativa.iniciativaInstitucional.nome.length > 70">
                    <template v-slot:activator="{ on }">
                      <div v-on="on" style="display: inline;" class="cardTextoIniciativas">
                        {{ iniciativa.iniciativaInstitucional.nome.substring(0, 70) }}
                      </div>
                      <tooltip-help
                        width="400"
                        @mouseover="tooltipText = false"
                        :text="iniciativa.iniciativaInstitucional.descricao"
                        style="display: none;"
                      />
                    </template>
                    <span v-if="!tooltipText">{{ iniciativa.iniciativaInstitucional.nome }}</span>
                  </v-tooltip>

                  <div v-else class="cardTextoIniciativas">
                    {{ iniciativa.iniciativaInstitucional.nome }}
                    <tooltip-help width="400" :text="iniciativa.iniciativaInstitucional.descricao" />
                  </div>
                </v-col>
                <v-col
                  v-if="iniciativa.aderida"
                  cols="auto"
                  sm="12"
                  md="3"
                  :class="$vuetify.breakpoint.xs ? 'pt-0 pb-10' : 'pt-4 pb-2'"
                >
                  <datepicker-cadu
                    :validateProviderRules="iniciativa.aderida ? 'required|yearAndMonthValidator' : ''"
                    :inputTitle="''"
                    :inputValue="iniciativa.dataAdessao"
                    :disabled="permissaoEditar"
                    @value="(value) => (iniciativa.dataAdessao = value)"
                    typeCalendar="month"
                    width="300"
                  ></datepicker-cadu>
                </v-col>
              </v-row>
            </ValidationObserver>
          </div>
          <v-row v-else>
            <v-col cols="12" sm="12" md="12">
              <div class="listaNenhumRegistro">
                <div class="child">Nenhuma iniciativa institucional aderida.</div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <v-row v-if="loading">
      <v-col cols="12" sm="12" md="11" class="pt-10">
        <component-loading :value="loading" />
      </v-col>
    </v-row>

    <overlay-loading v-model="loadingOverlay" />

    <error-modal v-model="showError" :errObj="errObj" />
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import { ValidationObserver } from 'vee-validate'
import { mask } from 'vue-the-mask'
import { EventBus } from '@/services/EventBus/EventBus'
import { cloneDeep } from 'lodash'

import IniciativaAderida from '@/services/Certificação/IniciativaAderida/IniciativaAderida'

import ValidationMixin from '@/Mixins/ValidationMixin'

export default {
  mixins: [ValidationMixin],
  directives: {
    mask
  },
  components: {
    ValidationObserver
  },
  data() {
    return {
      listaIniciativa: [],
      cloneListaIniciativa: [],

      loading: false,
      loadingOverlay: false,
      indexSwitch: -1,

      tooltipText: false,
      showByIndex: -1,

      // Error Modal
      showError: false,
      errObj: { status: 'Status', error: 'Error' },

      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit'))
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role

    this.getIniciativas()
  },
  mounted() {
    EventBus.$on('salvarIniciativas', async () => {
      const res = await this.handlerSalvar()

      return res
    })
  },
  methods: {
    async getIniciativas() {
      this.loading = true

      const iniciativa = new IniciativaAderida(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await iniciativa
        .getIniciativas()
        .then((res) => {
          this.listaIniciativa = res.data
          this.cloneListaIniciativa = cloneDeep(res.data)
        })
        .catch((err) => console.error(err))
        .finally(() => (this.loading = false))
    },
    async validarMudanca() {
      await this.getIniciativas()
    },
    anexar() {
      EventBus.$emit('showAnexo', 'Certificações')
    },

    changeSwitch(input) {
      if (!input) {
        this.listaIniciativa[this.indexSwitch].dataAdessao = null
      }
    },

    async handlerSalvar(boolean = false) {
      if (this.loading) return false

      if (!this.getDiffInObjects(this.cloneListaIniciativa, this.listaIniciativa)) return true

      const res = await this.$refs.observer.validate()

      if (res) {
        this.loadingOverlay = true
        const iniciativa = new IniciativaAderida(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

        return await iniciativa
          .putIniciativas(this.listaIniciativa)
          .then(() => {
            if (boolean) return true

            return true
          })
          .catch((err) => {
            console.error(err)

            this.errObj.status = err.response.status
            this.errObj.error = err.response.data.message
            this.showError = true

            return false
          })
          .finally(() => (this.loadingOverlay = false))
      }
    }
  },
  watch: {
    iniciativaDataAdesao() {
      if (this.iniciativa.dataAdessao === '') {
        this.iniciativa.dataAdessao = null
      }
    }
  },

  computed: {
    listaIniciativaFiltrada() {
      return this.listaIniciativa.filter((el) => {
        return true;
      })
    },
    isAdminBrasil() {
      return this.role === 'admin_brasil'
    },

    permissaoEditar() {
      if (this.role === 'admin_brasil' && this.opcaoEditar) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style scoped>
.iniciativas-lista {
  width: 100%;
  height: 450px;
  overflow-x: hidden;
  overflow-y: scroll;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}

.listaNenhumRegistro {
  width: 100%;
  height: 450px;
  overflow-x: hidden;
  overflow-y: hidden;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  text-align: center;
  font-size: 20px;
  display: table;
}

.child {
  display: table-cell;
  vertical-align: middle;
  padding-left: 20px;
}

.texto-Iniciativa {
  color: #00995d;
  font-weight: bold;
  font-size: 20px;
}

.cardTextoIniciativas {
  font-size: 1rem;
}
</style>
